package com.isaias.fyattravel.web.components

import androidx.compose.runtime.Composable
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import com.isaias.fyattravel.web.theme.ThemeColors

private const val FUNCTIONS_BASE = "https://us-central1-fyattravelnew.cloudfunctions.net"

/**
 * Shared email input used by the Flights/Stays/Transfer inquiry forms.
 */
@Composable
fun EmailInputBox(label: String, value: String, isInvalid: Boolean, onValueChange: (String) -> Unit) {
    Div {
        Label(null, {
            style {
                fontSize(0.8.em)
                color(ThemeColors.textSecondary)
                marginBottom(0.25.em)
                display(DisplayStyle.Block)
            }
        }) { Text(label) }
        Input(type = InputType.Email, attrs = {
            this.value(value)
            onInput { onValueChange(it.value) }
            style {
                width(100.percent)
                padding(0.75.em)
                borderRadius(0.5.em)
                property("border", "1px solid ${if (isInvalid) ThemeColors.error else ThemeColors.borderLight}")
                backgroundColor(ThemeColors.surface)
                fontWeight("600")
                property("box-sizing", "border-box")
            }
        })
    }
}

private fun jsonEscape(value: String): String =
    value.replace("\\", "\\\\").replace("\"", "\\\"").replace("\n", "\\n").replace("\r", "")

/**
 * Sends a form inquiry (Flights/Stays/Transfer) to the submitInquiry Cloud Function,
 * which emails info@fyattraveltour.com via the Firestore "mail" collection.
 */
fun submitInquiry(
    type: String,
    email: String,
    fields: Map<String, String>,
    onResult: (success: Boolean, message: String?) -> Unit,
) {
    val fieldsJson = fields.entries.joinToString(",") { (k, v) ->
        "\"${jsonEscape(k)}\":\"${jsonEscape(v)}\""
    }
    val bodyJson = "{\"type\":\"${jsonEscape(type)}\",\"email\":\"${jsonEscape(email)}\",\"fields\":{$fieldsJson}}"

    window.fetch(
        "$FUNCTIONS_BASE/submitInquiry",
        RequestInit(
            method = "POST",
            headers = Headers().also { h -> h.append("Content-Type", "application/json") },
            body = bodyJson
        )
    ).then { resp ->
        resp.text().then { text ->
            try {
                val obj = kotlin.js.JSON.parse<dynamic>(text)
                val ok = (obj.success as Boolean?) == true
                onResult(ok, if (!ok) (obj.message as String?) else null)
            } catch (t: dynamic) {
                onResult(false, "Invalid response from server")
            }
        }
    }.catch { _ ->
        onResult(false, "Network error. Please check your connection.")
    }
}
